
import { mapGetters } from 'vuex';

export default {
  name: 'PageComponent',
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters({
      artists: 'settings/artists',
      festival: 'settings/festival'
    }),
    backgroundClass() {
      return this.$backgroundClassPicker(this.data.backgroundColor);
    },
    prevLink() {
      const lineUp = [...this.festival.day1.artists, ...this.festival.day2.artists];
      const prevArtistIndex = lineUp.map((l) => l._ref).indexOf(this.data._id);
      if (prevArtistIndex <= 0) {
        return false;
      }

      const artist = this.artists.find((a) => a._id === lineUp[prevArtistIndex - 1]._ref);
      return artist.url.fullPath;
    },
    nextLink() {
      const lineUp = [...this.festival.day1.artists, ...this.festival.day2.artists];
      const nextArtistIndex = lineUp.map((l) => l._ref).indexOf(this.data._id);
      if (nextArtistIndex === lineUp.length || !lineUp[nextArtistIndex + 1]) {
        return false;
      }

      const artist = this.artists.find((a) => a._id === lineUp[nextArtistIndex + 1]._ref);
      return artist.url.fullPath;
    }
  },
  mounted() {
    // Useful resource to understand this line:
    // https://dmitripavlutin.com/vue-next-tick/
    this.$nextTick(() => (this.show = true));
  },
  methods: {
    getIdFromUrl(url) {
      if (!url) {
        return '';
      }

      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[7].length === 11 ? match[7] : false;
    }
  }
};
